//AuthConstants
export const AUTH_URL = `/api/auth`
export const USER_LOGIN_URL = `${AUTH_URL}/login`
export const GOOGLE_LOGIN_URL = `${AUTH_URL}/glogin`
export const USER_REGISTER_URL = `${AUTH_URL}/register`
export const ME_USER_URL = `${AUTH_URL}/me`
export const USER_LOGOUT_URL = `${AUTH_URL}/logout`
export const VERIFY_EMAIL = `${AUTH_URL}/verify_email`
export const RESEND_VERIFICATION = `${AUTH_URL}//resend_verification_email`
export const RESET_PASSWORD = `${AUTH_URL}/reset_password`
export const REQUEST_RESET_PWD = `${AUTH_URL}/request_password_reset`
export const DEACTIVATE_SELF = `${AUTH_URL}/deactivate_self`
export const SAML_SP_INITIATED = `${AUTH_URL}/oktalogin`
export const VERIFY_2FA = `${AUTH_URL}/verify_2fa`
export const SEND_EMAIL_OTP = `${AUTH_URL}/send_email_otp`
export const GET_LOGGED_IN_USER_DETAILS = `${AUTH_URL}/details`

// Approval Constants
export const CHANGE_REQ_URL = `/api/change_request`
export const ALL_CHANGE_REQ = `${CHANGE_REQ_URL}/all_requests`
export const UPDATE_CHANGE_REQ = `${CHANGE_REQ_URL}/update_change_request`
export const UPDATE_ROLE = `${CHANGE_REQ_URL}/request_change/role`
